import { AdhesionMode } from './getAdhesionDetails';

// Sincroniza los movimientos de póliza Caser hacia `pension_plan_contributions`
// (la tabla que lee la vista de Aportaciones vía `user-aportations-by-type`).
//
// `mode` (espejo de getAdhesionDetails): fuerza el plan a sincronizar. Sin él, el
// backend deriva del estado físico del user y los individuales/mixtos caen en
// EMPLOYMENT → el plan individual nunca se sincroniza. La vista Personal debe
// pasar 'INDIVIDUAL'/'FREELANCE' para poblar el plan correcto.
const syncAllMovements = async (token: string, mode?: AdhesionMode) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/sync-all-movements`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		...(mode ? { body: JSON.stringify({ mode }) } : {})
	});

	return response.json();
};

export default syncAllMovements;
